<template>
  <div class="single-income">
    <div class="total">
      <el-row type="flex">
        <el-col :lg="7" :xs="8" class="">
          <span>余额</span>
          <p style="color: #3D69CA">{{info.balance || 0 | currency('¥ ')}}</p>
        </el-col>
        <el-col :lg="7" :xs="8" class="">
          <span>可提现金额</span>
          <p>{{info.can_withdraw_amount || 0 | currency('¥ ')}}</p>
        </el-col> 
        <el-col :lg="7" :xs="8" class="">
          <span>已提现金额</span>
          <p>{{info.has_withdraw_amount || 0 | currency('¥ ')}}</p>
        </el-col>
        <el-col :lg="3" :xs="24">
          <Withdraw :max="info.can_withdraw_amount || 0" v-on:success="init"><el-button class="block btn-14 float-right" type="info">提现</el-button></Withdraw>
        </el-col>
      </el-row>
    </div>
    <div v-if="!list" class="text-center">
      <Loading></Loading>
    </div>
    <div v-if="list" class="list">
      <el-row type="flex" class="header">
        <el-col :lg="4" :xs="8" class="">
          入账时间
        </el-col>
        <el-col :lg="16" :xs="14" class="">
          交易详情
        </el-col>
        <el-col :lg="4" :xs="6" class="text-right">
          收支金额
        </el-col>
      </el-row>
      <el-row type="flex" v-for="(item,index) in list" :key="index">
        <el-col :lg="4" :xs="8" class="">
          <p>{{item.create_time | dateFilter}}</p>
          <span>{{item.create_time | moment('HH:mm:ss')}}</span>
          <!--<span>{{(new Date(item.create_time).getHours()== 0? '00':new Date(item.create_time).getHours())+' : '+ ((new Date(item.create_time).getMinutes().toString()).length<2? ('0'+new Date(item.create_time).getMinutes()):new Date(item.create_time).getMinutes())}}</span>-->
        </el-col>
        <el-col :lg="16" :xs="14" class="">
          <p v-if="item.type != 2">{{item.business_name}} 任务# {{item.order_no}}</p>
          <span v-if="item.type == 3 && item.shipping_status != '3' && item.shipping_status != '1'">已发货</span>
          <span v-if="item.type == 3 && item.shipping_status == '1' && item.shipping_type == 0">通过发货审核</span>
          <span v-if="item.type == 3 && item.shipping_status == '1'  && item.shipping_type == 1">用户签收</span>
          <span v-if="item.type == 3 && item.shipping_status == '1'  && item.shipping_type == 2">系统签收</span>
          <span v-if="item.type == 3 && item.shipping_status == '3'">用户签收</span>
          <span v-if="item.type == 4 && item.shipping_status != '1'">已发货</span>
          <span v-if="item.type == 1">用户签收</span>
          <div v-for="pay in withdrawList" v-if="item.type == 2 && item.payment_type==pay.type" class = "payInfo">
            {{pay.bank_name}}&nbsp;&nbsp;{{pay.card_number}}
          </div>
          <span v-if="item.type == 2">提现</span>
        </el-col>
        <el-col :lg="4" :xs="6" class="text-right">
          <p v-if="item.type == 3">{{item.amount | currency('')}}</p> 
          <p v-if="item.type == 1">{{item.amount | currency('')}}</p>
          <p v-if="item.type == 4 && item.shipping_status != '1'">{{item.amount | currency('')}}</p>
          <p v-if="item.type == 4 && item.shipping_status == '1'">-{{item.amount | currency('')}}</p>
          <p v-if="item.type == 2">-{{item.amount | currency('')}}</p>
          <span v-if="item.type == 2 && item.withdraw_status == 0 && item.withdraw_api_response == 0">审核中</span>
          <span v-if="item.type == 2 && item.withdraw_status == 1 && item.withdraw_api_response == 2" >提现失败</span>
          <span v-if="item.type == 2 && item.withdraw_status == 1 && item.withdraw_api_response == 1">{{item.balance}}</span>
          <span v-if="item.type == 2 && item.withdraw_status == 2">审核未通过</span>
          <span v-if="item.type == 1">{{$decimalFormat((Number(item.balance) + Number(item.amount)),2)}}</span>
          <span v-if="item.type == 4 && item.shipping_status != '1'">已退款</span>
          <span v-if="item.type == 4 && item.shipping_status == '1'">{{item.balance}}</span>
          <span v-if="item.type == 3 && ['0','2'].indexOf(item.shipping_status) > -1">入账中</span>
          <span v-if="item.type == 3 && ['4'].indexOf(item.shipping_status) > -1">已取消</span>
          <span v-if="item.type == 3 && ['1','3'].indexOf(item.shipping_status) > -1">{{$decimalFormat((Number(item.balance) + Number(item.amount)),2)}}</span>
        </el-col>
      </el-row>
      <div class="yd-pagination" v-if="list && totalCount > form.limit">
        <el-pagination
          :page-size="form.limit"
          :pager-count="5"
          :current-page.sync="form.page"
          layout="pager, next"
          next-text="下一页"
          :total="totalCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../services/api.js'
import Withdraw from './components/Withdraw'
import Loading from '../../components/Loading'

let _ = require('lodash')

export default {
  name: 'AddAddress',
  components: {
    Withdraw: Withdraw,
    Loading: Loading
  },
  computed: {
  },
  created () {
    this.getIncome()
    this.getIncomeList()
    this.getIncomeListCount()
    this.getWithdrawList()
  },
  data () {
    return {
      form: {
        page: 1,
        limit: 10
      },
      info: {},
      list: null,
      totalCount: null,
      withdrawList: null
    }
  },
  methods: {
    init() {
      this.getIncome()
      this.page = 1
      this.getIncomeList()
      this.getIncomeListCount()
    },
    async getIncome () {
      let res = await api.getIncome(this)
      this.info = res.body.result
    },
    async getIncomeList () {
      let res = await api.getIncomeList(this, this.form)
      if(res.body.result == ''){
        this.list = []
      }else{
        this.list = res.body.result
        _.each(this.list, item => {
          console.log((new Date(item.create_time).getMinutes().toString()).length)
        })
      }
    },
    async getIncomeListCount () {
      let res = await api.getIncomeListCount(this, this.form)
      this.totalCount = Number(res.body.result)
    },
    async getWithdrawList () {
      let res = await api.getWithdrawList(this)
      this.withdrawList = res.body.result || []
    }
  },
  watch: {
    form: {
      handler: function (val, oldVal) {
        this.getIncomeList()
        this.getIncomeListCount()
      },
      deep: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .single-income {
    padding: 0 35px 60px;

    .total {
      .block {
        width: 108px;
        margin-top: 15px;
        margin-bottom: 50px;
      }

      span {
        font-size:14px;
        color: #333;
        line-height:26px;
      }

      p {
        font-size:33px;
        color: #666;
      }
    }

    .header {
      color: #333;
    }

    .list {
      .el-row {
        padding: 0 18px 18px;
        border-bottom: 1px solid #EBEBEB;
        margin-bottom: 18px;
      }

      p {
        font-size: 16px;
        padding-bottom: 5px;
      }

      span {
        color: #666;
      }
      .payInfo {
        font-size:16px;
        line-height:26px;
      }
    }

  }
@media screen and (max-width:1024px){
  .single-income {
    padding: 0 0 60px;

    .list {

      .el-row {
        padding: 0 0 18px;
      }
      p {
        line-height: 20px;

      }
    }

    .total { 
      .el-row {
        display: inline-block;
      }
      p {
        font-size: 18px;
      }
      .block {
            margin-bottom: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/single_user_center/IncomeDetail.vue